import { EstimateDeliveryInterface } from "layouts/CheckoutPayment/mobile/EstimateDelivery/@types";
import { useState, RefObject, useRef, useEffect, useContext } from "react";
import { useTheme } from "emotion-theming";
import { getPlatform } from "../helpers/index";
import { getStringFromId } from "../helpers/vernacular";
import { VERNACULAR_DEFAULT_MESSAGES, VERNACULAR_STRING_IDS } from "constants/vernacularConstants";
import { getIcons, ICONS_NAMES } from "helpers/utils/getIcons";
import { trackWidgetDropDownClick } from "layouts/Payment/common/dependencies/tracking";
import { PaymentContext } from "wrapper/PaymentWrapper/context/paymentContext";
import { get } from "../logics/src/utils/helpers";
import { allTrackingHandlerForApps } from "helpers/utils/trackingHandler";
import { PAGE_NAMES, TRACKING_EVENTS } from "../constants";


export const useEddConfig = ({ isExpanded, deliveryElementRef, isPriceDetailsAccordionOpen, setPriceDetailsAccordion, isApp }: EstimateDeliveryInterface) => {
    const theme = useTheme();
    const platform = getPlatform();
    const [accordian, setAccordian] = useState(isExpanded);
    const estimateDeliveryTitle = getStringFromId(VERNACULAR_STRING_IDS.ESTIMATE_DELIVERY, VERNACULAR_DEFAULT_MESSAGES.ESTIMATE_DELIVERY);
    const ArrowDown = getIcons(platform, ICONS_NAMES.ARROW_DOWN);
    const ArrowUp = getIcons(platform, ICONS_NAMES.ARROW_UP);


    useEffect(() => {
      if (isExpanded) {
        setAccordian(isExpanded);
      };
    }, [isExpanded]);

    // scroll to view when accordian opens
    const scrollToRef = (ref: RefObject<HTMLInputElement>) => {
      // 100 milliseconds for accordian to open and actual ref value is found
      setTimeout(() => {
        if (ref?.current) {
          ref.current.scrollIntoView({ behavior: "smooth" });
        }
      }, 100);
    };

    const myRef = useRef(null);

    const toggleAccordian = () => {
      if (!accordian) {
        scrollToRef(myRef);
        trackWidgetDropDownClick();
        // apps tracking  for delivery estimate on saved payment page
        allTrackingHandlerForApps({
          event: TRACKING_EVENTS.DELIVERY_ESTIMATE_TOOLIP_EXPAND,
          interactionLocation: PAGE_NAMES.SAVED_PAYMENT_PAGE,
          isApp: isApp || false,
        });
      }
      if (isPriceDetailsAccordionOpen) {
        setPriceDetailsAccordion(false);
      }
      setAccordian(!accordian);
    };

    const [productItems, setProductItems] = useState([]);

    const defaultProductImage = "https://adn-static1.nykaa.com/media/wysiwyg/Payments/edd-cart-item-image.svg";

    const paymentContext = useContext(PaymentContext);
    const cartInfo = get(paymentContext, "cartInfo");
    const items = get(cartInfo, "items");
    useEffect(() => {
      let products = [];
      if (items) {
        products = items.map((item: any) => ({
            productName: item?.name,
            deliveryDateText: item?.eddMessage,
            productImage: {
              url: item?.imageUrl ? item?.imageUrl : defaultProductImage,
            },
            isFreeSample: true,
            showBinIcon: false,
          }));
        setProductItems(products);
      };
    }, [items]);

    const config = {
      title: estimateDeliveryTitle,
      isAccordianOpened: accordian,
      toggleAccordian,
      endIcon: accordian ? ArrowUp : ArrowDown,
      theme,
      productItems,
      deliveryElementRef,
      setAccordian,
      myRef,
    };

    return config;
};
